export const IMAGE_COMPRESSION_SETTINGS = {
  targetSizeKb: 500,
  initialReductionFactor: 0.8,
  subsequentReductionFactor: 0.9,
  maxIterations: 20,
  jpegQualitySteps: [0.9, 0.8, 0.7, 0.6, 0.5, 0.4, 0.3],
} as const;
